var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { randomId } from '../lib-randomId';
import { dropdownMenuFocus } from '../dropdown-lib';
import { keydownToArrow, UP_DOWN_KEYS } from '../lib-menuFocus';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var DropdownList = /** @class */ (function (_super) {
    __extends(DropdownList, _super);
    function DropdownList(props) {
        var _this = _super.call(this, props) || this;
        _this.writeState = componentApi.writeState.bind(_this);
        _this.menuRef = React.createRef();
        _this.cgThrottle = componentApi.cgThrottle.bind(_this);
        _this.toCancel = [];
        _this.templates = [
            { name: 'dropdownListItem', description: 'The item in the dropdown list.' },
        ];
        _this.timeoutId = null;
        _this.mutationObserver = { disconnect: function () { } };
        _this.mutationObserverTab = { disconnect: function () { } };
        _this.removeMenuFocus = function () { };
        _this.setLIAttributes = _this.cgThrottle(function () {
            var _a;
            var liElements = __spreadArray([], (((_a = _this.menu()) === null || _a === void 0 ? void 0 : _a.children) || []), true);
            var arrayOfLiAttributes = liElements.map(function (element) {
                var li = element;
                var attributes = {
                    role: _this.getLIRole(li),
                };
                if (_this.isFlyOutMenuMode()) {
                    return attributes;
                }
                if (_this.isApplicationMenuMode()) {
                    return __assign(__assign({}, attributes), { id: _this.getLIId(li), isDisabled: _this.getLIAriaDisabled(li), tabindex: _this.getLITabindex(li), isExpanded: _this.getLIAriaExpanded(li), haspopup: _this.getLIHasPopup(li) });
                }
            });
            _this.writeState('arrayOfListItemsAttributes', arrayOfLiAttributes);
        });
        _this.readTemplate = componentApi.readTemplate.bind(_this);
        _this.state = {};
        _this.state['isSection'] = false;
        _this.state['arrayOfListItemsAttributes'] = [];
        _this.state['ariaLabbeledby'] = _this.props.srAriaLabbeledby;
        _this.onKeydown = _this.onKeydown.bind(_this);
        return _this;
    }
    DropdownList.prototype.render = function () {
        var _this = this;
        return (React.createElement("ul", { ref: this.menuRef, "aria-labelledby": this.state.ariaLabbeledby, role: this.getMenuRole(), "data-e2e": this.props.dataE2e, "data-dropdown-focus": "dropdown-list", onKeyDown: function (event) { return _this.onKeydown(event); }, className: "cg-dropdown-list" }, Object.values(this.readTemplate('dropdownListItem')).map(function (item, idx) {
            return (React.createElement("li", { "aria-disabled": _this.getLIAttributes(idx).isDisabled, id: _this.getLIAttributes(idx).id, tabIndex: _this.getLIAttributes(idx).tabindex, role: _this.getLIAttributes(idx).role, "aria-expanded": _this.getLIAttributes(idx).isExpanded, "aria-haspopup": _this.getLIAttributes(idx).haspopup, key: 'cogen-6209' + idx.toString() }, item));
        })));
    };
    DropdownList.prototype.menu = function () {
        return this.menuRef.current;
    };
    DropdownList.prototype.dropdown = function () {
        var _a;
        return (_a = this.menu()) === null || _a === void 0 ? void 0 : _a.closest('[data-dropdown-focus="dropdown"]');
    };
    DropdownList.prototype.tabsBar = function () {
        var _a;
        return (_a = this.dropdown()) === null || _a === void 0 ? void 0 : _a.querySelector('[data-dropdown-focus="dropdown-tab-bar"]');
    };
    DropdownList.prototype.parentLI = function () {
        var _a;
        return (_a = this.menu()) === null || _a === void 0 ? void 0 : _a.closest('li');
    };
    DropdownList.prototype.cg_change = function (prevProps) {
        if (prevProps.srAriaLabbeledby !== undefined &&
            prevProps.srAriaLabbeledby !== this.props.srAriaLabbeledby) {
            this.writeState('ariaLabbeledby', this.props.srAriaLabbeledby);
            this.mutationObserverTab.disconnect();
        }
    };
    DropdownList.prototype.getLIAttributes = function (index) {
        var liAttributes = this.state.arrayOfListItemsAttributes[index];
        if (!liAttributes) {
            return {};
        }
        return liAttributes;
    };
    DropdownList.prototype.onKeydown = function (event) {
        if (this.isApplicationMenuMode()) {
            keydownToArrow(event, UP_DOWN_KEYS);
        }
    };
    DropdownList.prototype.isApplicationMenuMode = function () {
        return this.props.menuMode === 'application';
    };
    DropdownList.prototype.isFlyOutMenuMode = function () {
        return this.props.menuMode === 'flyOut';
    };
    DropdownList.prototype.getMenuRole = function () {
        if (this.isApplicationMenuMode()) {
            if (this.state.isSection) {
                return 'group';
            }
            return 'menu';
        }
        return null;
    };
    DropdownList.prototype.getAriaLabbeledby = function () {
        var _a, _b, _c, _d;
        if (this.parentLI()) {
            var sectionId = (_b = (_a = this.parentLI()) === null || _a === void 0 ? void 0 : _a.querySelector('[data-dropdown-focus="dropdown-list-section"]')) === null || _b === void 0 ? void 0 : _b.id;
            if (sectionId) {
                this.writeState('isSection', true);
            }
            return sectionId || randomId();
        }
        var dropdown = (_c = this.menu()) === null || _c === void 0 ? void 0 : _c.closest('[data-dropdown-focus="dropdown"]');
        var selectedTabId = (_d = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelector('.cg-dropdown-tab-selected')) === null || _d === void 0 ? void 0 : _d.id;
        return selectedTabId || null;
    };
    DropdownList.prototype.getLIId = function (element) {
        if (this.isApplicationDesktopMenu(element)) {
            return element === null || element === void 0 ? void 0 : element.querySelector('ul').getAttribute('aria-labelledby');
        }
        return null;
    };
    DropdownList.prototype.isNotRequiredAttr = function (element) {
        if (this.isFlyOutMenuMode() ||
            (this.hasSubmenu(element) && !this.isApplicationDesktopMenu(element)) ||
            (this.hasNestedList(element) && !this.hasSubmenu(element)) ||
            this.hasCheckbox(element)) {
            return true;
        }
        return false;
    };
    DropdownList.prototype.getLIRole = function (element) {
        if (this.hasSeparator(element) && !this.hasNestedList(element)) {
            return 'separator';
        }
        if (this.isNotRequiredAttr(element)) {
            return null;
        }
        return 'menuitem';
    };
    DropdownList.prototype.getLITabindex = function (element) {
        if (this.isNotRequiredAttr(element)) {
            return null;
        }
        return -1;
    };
    DropdownList.prototype.getLIAriaDisabled = function (element) {
        if (element === null || element === void 0 ? void 0 : element.querySelector('[data-dropdown-disabled-item="true"]')) {
            return true;
        }
        return null;
    };
    DropdownList.prototype.getLIAriaExpanded = function (element) {
        if (element === null || element === void 0 ? void 0 : element.querySelector('[dropdown-data-expanded-listbox="false"]')) {
            return false;
        }
        if (element === null || element === void 0 ? void 0 : element.querySelector('[dropdown-data-expanded-listbox="true"]')) {
            return true;
        }
        return null;
    };
    DropdownList.prototype.getLIHasPopup = function (element) {
        if (this.isApplicationDesktopMenu(element)) {
            return 'menu';
        }
        return null;
    };
    DropdownList.prototype.isApplicationDesktopMenu = function (element) {
        return !!(element === null || element === void 0 ? void 0 : element.querySelector('[dropdown-data-expanded-listbox="true"], [dropdown-data-expanded-listbox="false"]'));
    };
    DropdownList.prototype.hasCheckbox = function (element) {
        return !!(element === null || element === void 0 ? void 0 : element.querySelector('[type="checkbox"]'));
    };
    DropdownList.prototype.hasSubmenu = function (element) {
        return !!(element === null || element === void 0 ? void 0 : element.querySelector('[data-dropdown-focus="dropdown-listbox"]'));
    };
    DropdownList.prototype.hasSeparator = function (element) {
        return !!(element === null || element === void 0 ? void 0 : element.querySelector('[data-dropdown="dropdown-separator"]'));
    };
    DropdownList.prototype.hasNestedList = function (element) {
        return !!(element === null || element === void 0 ? void 0 : element.querySelector('[data-dropdown-focus="dropdown-list"]'));
    };
    DropdownList.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.parentLI()) {
            this.removeMenuFocus = dropdownMenuFocus(this.menu(), '[tabindex="-1"]:not([role="separator"])');
        }
        this.mutationObserver = new MutationObserver(function (entries) {
            _this.setLIAttributes();
        });
        this.mutationObserver.observe(this.menu(), {
            subtree: true,
            childList: true,
            attributes: true,
        });
        if (!this.state.ariaLabbeledby) {
            this.writeState('ariaLabbeledby', this.getAriaLabbeledby());
            if (this.tabsBar()) {
                this.mutationObserverTab = new MutationObserver(function (entries) {
                    _this.writeState('ariaLabbeledby', _this.getAriaLabbeledby());
                });
                this.mutationObserverTab.observe(this.tabsBar(), {
                    subtree: true,
                    childList: true,
                    attributes: true,
                });
            }
        }
    };
    DropdownList.prototype.componentWillUnmount = function () {
        this.mutationObserver.disconnect();
        this.removeMenuFocus();
        clearTimeout(this.timeoutId);
        this.mutationObserverTab.disconnect();
        this.toCancel.forEach(function (cancelableFunc) {
            cancelableFunc();
        });
    };
    DropdownList.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    DropdownList.defaultProps = {
        dataE2e: 'cg-dropdown-list',
        slot: 'dropdown-list',
        srAriaLabbeledby: null,
        menuMode: 'application',
    };
    DropdownList.displayName = 'DropdownList';
    return DropdownList;
}(React.Component));
export { DropdownList };
